<template lang="html">
  <section>
    <v-row dense class="mt-5 justify-center">
      <v-col cols="11">
        <v-card>
          <v-card-title color="orange accent-1">
            Abwesenheiten
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="2">
                <v-text-field id="vonAbsence" placeholder="DD.MM.YYYY" ref="vonAbsence"
                  label="Von"
                  :value="vonAbsence"
                  readonly
                  dense
                  @click="menuStartAbsence = true">

                  <template v-slot:append>
                    <v-menu ref="menuStartAbsence" v-model="menuStartAbsence" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="vonAbsence" type="month"
                        @input="menuStartAbsence = false" />
                    </v-menu>
                    </template>
                </v-text-field>
              </v-col>

              <v-col cols="2">
                <v-text-field id="bisAbsence" placeholder="DD.MM.YYYY" ref="bisAbsence" 
                  label="Bis"
                  :value="bisAbsence"
                  readonly
                  dense
                  @click="menuEndAbsence = true">

                  <template v-slot:append>
                    <v-menu ref="menuEndAbsence" v-model="menuEndAbsence" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="bisAbsence" type="month"
                        @input="menuEndAbsence = false" />
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>

              

              <v-col cols="2">
                <v-btn id="generateAbsenceReportButton" type="button" :loading="loading" @click.native="generateAbsencesReport()" color="#c00000" class="white--text">Abwesenheiten Report erstellen</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row dense class="justify-center">
      <v-col cols="11">
        <v-card>
          <v-card-title color="orange accent-1">
            HomeOffice
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="2">
                <v-text-field id="vonHO" placeholder="DD.MM.YYYY" ref="vonHO"
                  label="Von"
                  :value="vonHO"
                  readonly
                  dense
                  @click="menuStartHO = true">

                  <template v-slot:append>
                    <v-menu ref="menuStartHO" v-model="menuStartHO" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="vonHO" type="month"
                        @input="menuStartHO = false" />
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="2">
                <v-text-field id="bisHO" placeholder="DD.MM.YYYY" ref="bisHO"
                  label="Von"
                  :value="bisHO"
                  readonly
                  dense
                  @click="menuEndHO = true">

                  <template v-slot:append>
                    <v-menu ref="menuEndHO" v-model="menuEndHO" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="bisHO" type="month"
                        @input="menuEndHO = false" />
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="2">
                <v-btn id="generateHOReportButton" type="button" :loading="loading" @click.native="generateHomeOfficeReport()" color="#c00000" class="white--text">HomeOffice Report erstellen</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="justify-center">
      <v-col cols="11">
        <v-card>
          <v-card-title color="orange accent-1">
            Zeitsalden
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="2">
                <v-text-field id="dateZeitsalden" class="ma-0 pa-0" placeholder="DD.MM.YYYY" ref="dateZeitsalden"
                  label="Monat"
                  :value="dateZeitsalden"
                  readonly
                  dense
                  @click="menuZeitsalden = true">

                  <template v-slot:append>
                    <v-menu ref="menuZeitsalden" v-model="menuZeitsalden" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="dateZeitsalden" type="month"
                        @input="menuZeitsalden = false" />
                    </v-menu>
                    </template>
                </v-text-field>
              </v-col>

              <v-col cols="2">
                <v-btn id="generateZeitsaldenButton" type="button" :loading="loading" @click.native="generateZeitsaldenReport()" color="#c00000" class="white--text">Zeitsalden Report erstellen</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar id="errorMessage" v-if="errorHandling.showError" v-model="errorHandling.showError" bottom
      color="red accent-2">
      <v-progress-circular indeterminate color="white"> </v-progress-circular>
      {{ errorHandling.errorMessage }}
    </v-snackbar>
  </section>
</template>

<script lang="js">
  import dayjs from '@util/dayjs';
  import * as hrClient from '@client/client.hr';

  const lastMonth = dayjs().subtract(1, 'month').format('YYYY-MM');

  export default {
    name: 'Reports',
    data() {
      return {
        loading: false,
        vonAbsence: lastMonth,
        bisAbsence: lastMonth,
        vonHO: lastMonth,
        bisHO: lastMonth,
        menuStartAbsence: false,
        menuEndAbsence: false,
        menuStartHO: false,
        menuEndHO: false,
        menuZeitsalden: false,
        dateZeitsalden: lastMonth,
        errorHandling: {
          showError: false,
          errorMessage: ''
        },
      }
    },

    computed: {
      fromHO: function() {
        return dayjs(this.vonHO).startOf('month').format('YYYY-MM-DD');
      },
      toHO: function() {
        return dayjs(this.bisHO).endOf('month').format('YYYY-MM-DD');
      },
      fromAbsence: function() {
        return dayjs(this.vonAbsence).startOf('month').format('YYYY-MM-DD');
      },
      toAbsence: function() {
        return dayjs(this.bisAbsence).endOf('month').format('YYYY-MM-DD');
      },
      monthZeitsalden: function() {
        return dayjs(this.dateZeitsalden).endOf('month').format('M');
      },
      yearZeitsalden: function() {
        return dayjs(this.dateZeitsalden).endOf('month').format('YYYY');
      }
    },

    methods: {
      async generateAbsencesReport() {
        try {
          this.loading = true;
          const csvString = await hrClient.generateAbsencesReport(this.fromAbsence, this.toAbsence);
          this._downloadCSV(csvString, 'Abwesenheit_Report', this.fromAbsence, this.toAbsence);
        } catch (error) {
          this.errorHandling.showError = true;
          this.errorHandling.errorMessage = `Report-Generierung ist fehlgeschlagen.\n\n Error: ${error.message}`;
        } finally {
          this.loading = false;
        }
      },

      async generateHomeOfficeReport() {
        try {
          this.loading = true;
          const csvString = await hrClient.generateHomeOfficeReport(this.fromHO, this.toHO);
          this._downloadCSV(csvString, 'HomeOffice_Report', this.fromHO, this.toHO);
        } catch (error) {
          this.errorHandling.showError = true;
          this.errorHandling.errorMessage = `Report-Generierung ist fehlgeschlagen.\n\n Error: ${error.message}`;
        } finally {
          this.loading = false;
        }
      },

      async generateZeitsaldenReport() {
        try {
          this.loading = true;
          const csvString = await hrClient.generateZeitsaldenReport(this.monthZeitsalden, this.yearZeitsalden);
          this._downloadCSV(csvString, 'Zeitsalden_Report', this.dateZeitsalden);
        } catch (error) {
          this.errorHandling.showError = true;
          this.errorHandling.errorMessage = `Report-Generierung ist fehlgeschlagen.\n\n Error: ${error.message}`;
        } finally {
          this.loading = false;
        }
      },

      _downloadCSV(csvString, filename, from, to) {
        const mocoEnv = this.$store.getters.userAuthenticationData.mocoEnv;
        const fromMonth = dayjs(from).format('YYYY_MM');
        const toMonth = to ? dayjs(to).format('YYYY_MM') : undefined;
        
        let filenameAddOns;
        if (toMonth == undefined || fromMonth == toMonth) {
          filenameAddOns = `${mocoEnv}_${fromMonth}`;
        } else {
          filenameAddOns = `${mocoEnv}_${fromMonth}-${toMonth}`;
        }
        
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}_${filenameAddOns}.csv`); 

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
  }
</script>
  
<style lang="scss">
#testarea .chip span {
  cursor: pointer;
}
</style>